import {Component, HostBinding, OnInit} from '@angular/core';
import {BlocksComponent} from '../blocks.component';

@Component({
  selector: 'app-page',
  templateUrl: '../blocks.component.html',
  styleUrls: [
    '../blocks.component.scss',
    './page.component.scss'
  ]
})
export class PageComponent extends BlocksComponent implements OnInit {

  ngOnInit() {
    super.ngOnInit();
  }

  @HostBinding('class.d-print-none') get hideInExport(): boolean {
    return this.block.settings.hideInExport;
  }

  @HostBinding('attr.data-block-id') get dataBlockId(): string {
    return '' + this.block.id;
  }
}
